import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=1e7e165a&scoped=true&"
import script from "./Tel.vue?vue&type=script&lang=js&"
export * from "./Tel.vue?vue&type=script&lang=js&"
import style0 from "./Tel.vue?vue&type=style&index=0&id=1e7e165a&prod&lang=less&scoped=true&"
import style1 from "./Tel.vue?vue&type=style&index=1&id=1e7e165a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7e165a",
  null
  
)

export default component.exports